const logs = {
    page_title: 'Dziennik audytu',
    title: 'Dziennik audytu',
    subtitle: 'Wyświetl dane dziennika dotyczące zdarzeń uwierzytelnienia dokonywanych przez Twoich użytkowników',
    event: 'Zdarzenie',
    user: 'Użytkownik',
    application: 'Aplikacja',
    time: 'Czas',
    filter_by: 'Filtruj według',
    last_1_hour: 'Ostatnia godzina',
    last_24_hours: 'Ostatnie 24 godziny',
    last_7_days: 'Ostatnie 7 dni',
    last_30_days: 'Ostatnie 30 dni',
    custom_range: 'Zakres niestandardowy',
    from: 'Od',
    to: 'Do',
};
export default Object.freeze(logs);
